/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbRespRefineMenuSelector_user$ref = any;
type SbRespSearchResultContainer_user$ref = any;
type SbSharedRelatedItems_user$ref = any;
export type SbRespMainContent_user$ref = any;
export type SbRespMainContent_user = {
    readonly canShowSellerName: boolean | null;
    readonly canShowInternalSellerName: boolean | null;
    readonly " $fragmentRefs": SbRespRefineMenuSelector_user$ref & SbRespSearchResultContainer_user$ref & SbSharedRelatedItems_user$ref;
    readonly " $refType": SbRespMainContent_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbRespMainContent_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "canShowSellerName",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": "canShowInternalSellerName",
            "name": "hasPermission",
            "args": [
                {
                    "kind": "Literal",
                    "name": "name",
                    "value": "VIEW_SELLER_NAME"
                }
            ],
            "storageKey": "hasPermission(name:\"VIEW_SELLER_NAME\")"
        },
        {
            "kind": "FragmentSpread",
            "name": "SbRespRefineMenuSelector_user",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "SbRespSearchResultContainer_user",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "SbSharedRelatedItems_user",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'd564a926f55bb9c3bf04df718300251b';
export default node;
